var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackBtn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 40,
    viewBox: "0 0 24 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2375",
    "data-name": "Groupe 2375",
    transform: "translate(-29.744 -55.989)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "expand_more_FILL1_wght400_GRAD0_opsz48",
    d: "M15.08,17.221a1.954,1.954,0,0,1-.732-.133,2.028,2.028,0,0,1-.666-.466L.5,3.441A1.832,1.832,0,0,1,0,2.01,2.048,2.048,0,0,1,.568.579,1.67,1.67,0,0,1,2,.013,2.5,2.5,0,0,1,3.364.645L15.08,12.361,26.8.645a2.174,2.174,0,0,1,1.431-.6,1.575,1.575,0,0,1,1.431.6,1.467,1.467,0,0,1,.566,1.4,2.592,2.592,0,0,1-.632,1.464L16.478,16.622a2.028,2.028,0,0,1-.666.466A1.954,1.954,0,0,1,15.08,17.221Z",
    transform: "translate(50.593 60.631) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1786",
    "data-name": "Rectangle 1786",
    width: 24,
    height: 40,
    transform: "translate(29.744 55.989)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackBtn);
export default __webpack_public_path__ + "static/media/back_btn.1117696889f3a3e219e5612d1478afbc.svg";
export { ForwardRef as ReactComponent };